module.exports = __webpack_public_path__ + "2f50186560586898d8e7baae4cc9b1f9.svg";